import React from 'react';
import Dropdown from '@ax2/common/components/Dropdown';
import ReportType, { getReportTypeText } from 'model/reports/ReportType';

export interface ReportTypeDropdownData {
  value: ReportType;
  options: ReportType[];
  disabled?: boolean;
  onChange?: (s: ReportType) => void;
}

export const ReportTypeDropdown: React.FC<ReportTypeDropdownData> = props => {
  const options = props.options.map(option => ({
    title: getReportTypeText(option),
    value: option,
  }));
  return (
    <Dropdown
      options={options}
      value={props.value}
      disabled={props.disabled}
      onChange={props.onChange}
    />
  );
};
